import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { SnackbarProvider } from 'notistack';

import rootReducer from './reducers';
import Root from './domains/Root/application/root';
import './styles/index.scss';

const store = createStore(rootReducer);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={3000}
      >
        <Root />
      </SnackbarProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);
